import requestor from "../../requestor";

export default class CallcenterApi {
  client = {
    all: (page = 1, client_id = null) =>
      requestor.get("/callcenter/client_all", {
        page: page,
        filter: { client_id: client_id },
      }),
    one: (id) => requestor.get("/callcenter/client_one", { id: id }),
    bindManager: (id, manager_id) =>
      requestor.put("/callcenter/client_bind_manager", { id: id, manager_id: manager_id }),
    comment: (client_id, text) => requestor.post("/callcenter/client_comment", { client_id: client_id, text: text }),
    message: (client_id, text, type) =>
      requestor.post("/callcenter/client_message", { client_id: client_id, text: text, type: type }),
    toggleBan: (id) => requestor.patch("/callcenter/client_toggle_ban", { id: id }),
    autocomplete: (query, page = 1, limit = 10) =>
      requestor.get("/callcenter/client_autocomplete", { query: query, page: page, limit: limit }),
    sendPassRestoreLink: (id) => requestor.get("/callcenter/client_send-pass-restore-link", { id: id }),
  };

  order = {
    all: (page = 1, search = "", from = "", to = "", status = "", substate = "", seller_id = "", client_id = null) =>
      requestor.get("/callcenter/order_all", {
        page,
        filter: {
          search: search,
          from: from,
          to: to,
          status: status,
          substate: substate,
          seller_id: seller_id,
          client_id: client_id,
        },
      }),
    one: (id) => requestor.get("/callcenter/order_one", { id }),
    remind: {
      send: (id) => requestor.put("/callcenter/order_remind_send", { id: id }),
      save: (id, datetime) =>
        requestor.patch("/callcenter/order_remind_save", {
          id: id,
          date_remind: datetime,
        }),
    },
    content: {
      send: (id) => requestor.put("/callcenter/order_content_send", { id: id }),
      view: (id) => requestor.get("/callcenter/order_content_view", { id: id }),
    },
    comment: (id, comment) => requestor.post("/callcenter/order_comment_update", { id: id, comment: comment }),
    clientHistory: (client_id) => requestor.get("/callcenter/order_client_history", { client_id: client_id }),
    setStatus: (id, state_id) => requestor.put("/callcenter/order_set_status", { id: id, state_id: state_id }),
    setSubstate: (id, substateId, dateRemind = null) =>
      requestor.put("/callcenter/order_set_substate", {
        id: id,
        substate_id: substateId,
        date_remind: dateRemind,
      }),
    handlePaid: (id, receiverServiceInstanceId, paymentTypeId, paymentFee, useCashier) =>
      requestor.put("/callcenter/order_handle_paid", {
        id: id,
        receiver_service_instance_id: receiverServiceInstanceId,
        payment_type_id: paymentTypeId,
        payment_fee: paymentFee,
        use_cashier: useCashier,
      }),
    setManager: (id, manager_id) =>
      requestor.put("/callcenter/order_set_manager", {
        id: id,
        manager_id: manager_id,
      }),
    more: (orderId) => requestor.get("/callcenter/order_more", { id: orderId }),
    refund: (id, rsi_id) =>
      requestor.put("/callcenter/order_refund", {
        id: id,
        receiver_service_instance_id: rsi_id,
      }),
    npd: {
      cancelReceipt: (invoiceId) => requestor.post("/callcenter/order_npd_cancel-receipt", { id: invoiceId }),
    }
  };
}
